export default __webpack_public_path__ + "static/media/exit.1b2ac462.svg";